"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRiderAnalytics = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var RiderAnalyticsDay_1 = require("./RiderAnalyticsDay");
/**
 * @deprecated use `RiderStats` instead!
 */
var RiderAnalyticsStruct = (0, superstruct_1.type)({
    riderId: (0, superstruct_1.string)(),
    days: (0, superstruct_1.array)(RiderAnalyticsDay_1.RiderAnalyticsDayStruct),
});
function isRiderAnalytics(obj) {
    return (0, isStruct_1.isStruct)(obj, RiderAnalyticsStruct, "RiderAnalytics");
}
exports.isRiderAnalytics = isRiderAnalytics;
